<template>
  <div class="add-form">
    <div class="back-title">
      <span @click="onCancel"><i class="el-icon-back" /> 返回上一级</span>
    </div>

    <div class="form-title">
      <span>{{ form.name }} 的个人信息</span>
    </div>

    <el-form ref="form"
             label-width="120px"
             label-position="left">
      <el-form-item label="姓名"
                    prop="name">
        {{ form.name }}
      </el-form-item>
      <el-form-item label="用户名"
                    prop="account">
        {{ form.name }}
      </el-form-item>
      <el-form-item label="电子邮件"
                    prop="email">
        {{ form.email }}
      </el-form-item>
      <el-form-item label="手机号"
                    prop="phone">
        {{ form.phone }}
      </el-form-item>
      <el-form-item label="所属用户组"
                    prop="groups">
        <template v-if="form.groups">
          <span v-for="(group, gi) in form.groups"
                :key="gi">
            {{ group.name
            }}<template v-if="gi < form.groups.length - 1">,</template>
          </span>
        </template>
      </el-form-item>
      <el-form-item>
        <el-button v-if="form.email != 'developer'"
                   type="primary"
                   @click="onSubmit">
          修改
        </el-button>
        <el-button v-if="form.email != 'developer'"
                   type="danger"
                   @click="onDelete">
          删除
        </el-button>
        <el-button @click="onCancel">
          取消
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { queryUser, deleteUser } from '@/api/admin';

export default {
  props: {
    pid: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      form: {},
      query: {
        page: 1,
        size: 20,
      },
      data: [
        {
          key: 1,
          label: '备选项 1',
        },
      ],
    };
  },
  watch: {
    pid() {
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      const params = Object.assign({}, this.query);
      params.query_filters = { id: { relationship: 'e', value: [this.pid] } };
      queryUser(params).then((res) => {
        if (res.data && res.data && res.data.list.length > 0) {
          const [form, ..._] = res.data.list;
          this.form = form;
        }
      });
    },
    onDelete() {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteUser({ id: this.pid }).then((res) => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.onCancel();
            this.$store.dispatch('GetInfo');
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    onSubmit() {
      this.$emit('setRPQ', { r: 'add', p: this.pid });
    },
    onCancel() {
      this.$emit('setRPQ', { r: 'list', p: undefined });
    },
  },
};
</script>
